export const JSON_ONE = {
   
    "ag_id": "“paygate”",
    "me_id": 201701240003,
    "ag_ref": "GHDDH3873498SDZZM",
    "refund_amount": "TEYHAS3728AAOS",
    "refund_reason": "GHADL83898432BSDFMADFHZC"
    }



